import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { baseQuery } from "../baseQuery";

export const campaignApi = createApi({
    reducerPath: "campaignApi",
    baseQuery,
    tagTypes: ["campaign"],
    endpoints: (builder) => ({
        getCampaignInfo: builder.query({
            query: () => "campaign",
            providesTags: ["campaign"]
        })
    })
})
export const { useGetCampaignInfoQuery } = campaignApi